// src/components/calendar/CalendarControls.jsx

/**
 * CalendarControls Component
 *
 * Provides view mode toggle (List/Calendar) and create event button.
 * Handles switching between different calendar views.
 */
const CalendarControls = ({ viewMode, onViewModeChange, onCreateEvent }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-3 sm:p-4 mb-4 sm:mb-6">
      <div className="flex items-center justify-between gap-3">
        {/* View Mode Toggle - Larger touch targets for mobile */}
        <div className="flex bg-gray-100 rounded-lg p-1">
          <button
            onClick={() => onViewModeChange("list")}
            className={`px-4 py-2.5 sm:px-3 sm:py-1.5 text-sm font-medium rounded-md transition-all duration-200 flex items-center active:scale-95 ${
              viewMode === "list"
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-600 hover:text-gray-900 active:bg-gray-50"
            }`}
          >
            <svg
              className="w-5 h-5 sm:w-4 sm:h-4 mr-1.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M4 6h16M4 10h16M4 14h16M4 18h16"
              />
            </svg>
            <span className="hidden sm:inline">List</span>
          </button>
          <button
            onClick={() => onViewModeChange("calendar")}
            className={`px-4 py-2.5 sm:px-3 sm:py-1.5 text-sm font-medium rounded-md transition-all duration-200 flex items-center active:scale-95 ${
              viewMode === "calendar"
                ? "bg-white text-gray-900 shadow-sm"
                : "text-gray-600 hover:text-gray-900 active:bg-gray-50"
            }`}
          >
            <svg
              className="w-5 h-5 sm:w-4 sm:h-4 mr-1.5"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
            <span className="hidden sm:inline">Calendar</span>
          </button>
        </div>

        {/* Create Event Button - Larger and more prominent on mobile */}
        <button
          type="button"
          onClick={onCreateEvent}
          className="flex items-center justify-center px-4 py-2.5 sm:px-5 sm:py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 active:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-all duration-200 shadow-sm hover:shadow-md active:scale-95 font-medium text-sm sm:text-base"
        >
          <svg
            className="w-5 h-5 mr-2"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 6v6m0 0v6m0-6h6m-6 0H6"
            />
          </svg>
          <span className="whitespace-nowrap">Create Event</span>
        </button>
      </div>
    </div>
  );
};

export default CalendarControls;
